import { ApproveRequestDetail, RequestDetail } from 'models/approves/ReferenceOpinion';
import { PaginationResponse } from 'models/common/Pagination';
import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';

export const getMasterId = async () => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/getMasterId`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);

  return response;
};

//신규 요청시 결재 양식 불러오기
export const findAprReqTplInfo = async (aprTplId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/findAprReqTplInfo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprTplId },
    // queryParams: new URLSearchParams({ ...searchCondition }),
  };

  const response: CommonResponse<any> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as any;
};

export const saveApproveRequest = async (params: RequestDetail) => {
  console.log(params);
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/generalRequest`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: params,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const findApproveRequestList = async (searchCondition?: any) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/approval/getRequestList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...searchCondition }),
  };

  const response: CommonResponse<PaginationResponse<any>> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as PaginationResponse<any>;
};

export const findApproveRequestDetail = async (aprReqId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/generalRequestDetail`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprReqId },
    //queryParams: new URLSearchParams({ aprReqId }),
  };

  const response: CommonResponse<any> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as any;
};

/**
 * 결재요청화면유형(pageId) 조회
 * [2025.11.11] 결재요청화면유형(pageId) 조회 추가 (결재ID로만 화면 접근 시 어떤 요청건인지 확인하기 위해 추가)
 * @param aprReqId
 */
export const findApprovalPageId = async (aprReqId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/pageId`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprReqId },
  };

  const response: CommonResponse<string> = await callApi(request);
  return response.successOrNot === 'Y' ? response.data : null;
};

// 결재 승인
export const approveApprovalRequestResult = async (approveInfo: ApproveRequestDetail) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/approveRequestResult`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: approveInfo,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return response;
};

// 결재 반려
export const rejectApprovalRequestResult = async (approveInfo: ApproveRequestDetail) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/rejectRequestResult`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: approveInfo,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return response;
};

// 결재 취소
export const cancelApprovalRequestResult = async (aprReqId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/cancelRequestResult`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprReqId },
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return response;
};

/**
 * 임시저장 상태인 결재 삭제 처리
 * [25.11.23] FA 일정등록 요청만 임시 적용
 * @param aprReqId
 */
export const removeApprovalRequestResult = async (aprReqId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/removeRequestResult`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprReqId },
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return response;
};

/**
 * 반려 상태인 결재 재작성 처리
 * [25.11.23] 반려인 경우 재작성 노출 > 클릭 시 결재정보 복사해서 신규 결재데이터 생성 (FA 일정등록쪽만 임시 적용)
 * @param aprReqId
 */
export const rewriteApprovalRequestResult = async (aprReqId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/rewriteRequestResult`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { aprReqId },
  };
  const response: CommonResponse<string> = await callApi(request);

  return response;
};

/**
 * [26.01.14] ELM, 협력사 권한요청 시 기 결재 내역 조회
 * @param condition
 */
export const selectRequestedAuth = async (condition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/approval/requestedAuth`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<any> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as any;
};

/**
 * [26.01.20] CSR E20260108-002100 결재문서 임시저장(TMP)/상신취소(CCL)가 아닌 상태의 결재 공유메일 추가
 * @param condition
 */
export const saveApproveSendMailInfo = async (condition) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/approval/saveApproveSendMailInfo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};
